<div class="flex flex-row items-stretch justify-center m-auto gap-2">
    <app-button
        [disabled]="entityEditPanelGuardService.hasPendingEntityEdition() || !editModeStateService.canCancel()"
        [htmlType]="'button'"
        [icon]="['fas', 'rotate-left']"
        [iconSize]="'lg'"
        [tooltip]="undoTooltip() | transloco"
        [type]="ButtonType.SECONDARY"
        (click)="cancelLastEdit()" />
    <app-button
        [disabled]="entityEditPanelGuardService.hasPendingEntityEdition() || !editModeStateService.canReapply()"
        [htmlType]="'button'"
        [icon]="['fas', 'rotate-right']"
        [iconSize]="'lg'"
        [tooltip]="redoTooltip() | transloco"
        [type]="ButtonType.SECONDARY"
        (click)="reapplyLastEdit()" />
    <app-button
        [disabled]="isSubmitButtonDisabled()"
        [htmlType]="'button'"
        [icon]="['fas', 'check']"
        [iconSize]="'lg'"
        [tooltip]="submitTooltip() | transloco"
        [type]="ButtonType.SECONDARY"
        (click)="mapEditModeService.openEditModeConfirmationModal()" />
</div>
